import { useState, useRef } from "react";
import { C } from '../constants';

export default function Img({ src, size = 36 }) {
  const [hov, setHov] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const ref = useRef(null);

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-flex", flexShrink: 0 }}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      onMouseMove={() => {
        const r = ref.current?.getBoundingClientRect();
        if (r) setPos({ x: r.right + 8, y: Math.min(r.top, window.innerHeight - 210) });
      }}>
      {src ? (
        <img src={src} alt="" style={{ width: size, height: size, objectFit: "cover", borderRadius: 6, display: "block" }} />
      ) : (
        <div style={{ width: size, height: size, background: C.bg3, borderRadius: 6 }} />
      )}
      {hov && src && (
        <div style={{ position: "fixed", left: pos.x, top: pos.y, zIndex: 9999,
          background: C.bg2, border: `1px solid ${C.border}`, borderRadius: 10, padding: 8,
          pointerEvents: "none", boxShadow: "0 8px 32px rgba(0,0,0,.6)" }}>
          <img src={src} alt="" style={{ width: 180, height: 180, objectFit: "contain", borderRadius: 6 }} />
        </div>
      )}
    </div>
  );
}
